import { ReactComponent as TanningIcon } from "../../assets/icons/Icon_Tanning.svg";
import { ReactComponent as TanningBedIcon } from "../../assets/icons/Icon_Tanning_Bed.svg";
import { ReactComponent as TanningBoothIcon } from "../../assets/icons/Icon_Tanning_Booth.svg";
import { ReactComponent as HydroMassageIcon } from "../../assets/icons/Icon_HydroMassage.svg";
import { ReactComponent as MassageChairsIcon } from "../../assets/icons/Icon_MassageChairs.svg";
import { ReactComponent as SaunaIcon } from "../../assets/icons/Icon_Sauna.svg";
import { ReactComponent as TotalBodyIcon } from "../../assets/icons/Icon_TotalBody.svg";
import { ReactComponent as SprayTanIcon } from "../../assets/icons/Icon_Tanning_SprayBooth.svg";
import { ReactComponent as PEPFIcon } from "../../assets/icons/Icon_PEPF_Classes.svg";

export default {
  Tanning: TanningIcon,
  "Tanning Bed": TanningBedIcon,
  "Tanning Beds": TanningBedIcon,
  "Tanning Booth": TanningBoothIcon,
  "Tanning Booths": TanningBoothIcon,
  HydroMassage: HydroMassageIcon,
  "Hydro Massage": HydroMassageIcon,
  "HydroMassage Booth": HydroMassageIcon,
  "HydroMassage Bed": HydroMassageIcon,
  "HydroMassage Lounge": HydroMassageIcon,
  "Well System": HydroMassageIcon,
  "Aqua Frixio": HydroMassageIcon,
  "Aqua Frixio 3": HydroMassageIcon,
  "Massage Chairs": MassageChairsIcon,
  "Heated Massage": SaunaIcon,
  Sauna: SaunaIcon,
  "Total Body Enhancement": TotalBodyIcon,
  "Spray Tanning": SprayTanIcon,
  "PE@PF": PEPFIcon,
};
